import { pageTypes } from 'common/constants/pageTypes'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import React from 'react'
import { BlogLayoutSettingsResolver } from './blog-layout-settings'
import { BlogPageBodyResolver } from './blog-page-settings'
import { BlogPostLayoutSettings } from './blog-post-layout-settings'
import { BlogPostSettingsResolver } from './blog-post-settings'
import { CommonPageSettingsResolver } from './common-page-settings'
import { CommonWithoutSeoSettingsResolver } from './common-without-settings'
import { InlineFormSettings } from './inline-form-settings'
import { LectureSettingsResolver } from './lecture-settings'
import { RemotePopupFormSettings } from './remote-popup-settings'

export function createPageSettings(pageType: PageTypeEnum) {
  switch (pageType) {
    case PageTypeEnum.BlogLayout:
      return <BlogLayoutSettingsResolver />
    case PageTypeEnum.BlogPostLayout:
      return <BlogPostLayoutSettings />
    case PageTypeEnum.BlogPostBody:
      return <BlogPostSettingsResolver />
    case PageTypeEnum.BlogHome:
    case PageTypeEnum.BlogPostListing:
    case PageTypeEnum.BlogSearch:
    case PageTypeEnum.BlogStatic:
      return <BlogPageBodyResolver />
    case PageTypeEnum.Popup:
      return <RemotePopupFormSettings />
    case PageTypeEnum.Inline:
      return <InlineFormSettings />
    case pageTypes.courseIntroduction:
      return <CommonWithoutSeoSettingsResolver isSkipFont isSkipTitle />
    case PageTypeEnum.WebinarSession:
    case PageTypeEnum.NotFound:
    case PageTypeEnum.CustomLogin:
      return <CommonWithoutSeoSettingsResolver />
    case pageTypes.lecture:
      return <LectureSettingsResolver />
    default:
      return <CommonPageSettingsResolver />
  }
}
